import { render, staticRenderFns } from "./ShowPerformance.vue?vue&type=template&id=1d978bb4&scoped=true"
import script from "./ShowPerformance.vue?vue&type=script&lang=js"
export * from "./ShowPerformance.vue?vue&type=script&lang=js"
import style0 from "./ShowPerformance.vue?vue&type=style&index=0&id=1d978bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d978bb4",
  null
  
)

export default component.exports